"use client";

import { ReactComponent as LampSvg } from "../assets/icons/lamp.svg";
import { Box, keyframes } from "@mui/system";
import { Tooltip } from "@mui/material";

const pulse = keyframes`
0%   { filter: drop-shadow(0 0 4px #A39455) brightness(1); }
50%  { filter: drop-shadow(0 0 12px #A39455) brightness(1.2); }
100% { filter: drop-shadow(0 0 4px #A39455) brightness(1); }
`;

const pulseRed = keyframes`
0%   { filter: grayscale(1) opacity(0.6) drop-shadow(0 0 2px #ff0000) drop-shadow(0 0 4px #ff0000) drop-shadow(0 0 6px #ff0000); }
50%  { filter: grayscale(1) opacity(0.6) drop-shadow(0 0 3px #ff0000) drop-shadow(0 0 6px #ff0000) drop-shadow(0 0 10px #ff0000); }
100% { filter: grayscale(1) opacity(0.6) drop-shadow(0 0 2px #ff0000) drop-shadow(0 0 4px #ff0000) drop-shadow(0 0 6px #ff0000); }
`;

export const LampCell: React.FC<{ isUp: boolean; name?: string; error?: string }> = ({
  isUp,
  name,
  error,
}) => {
  const content = (
    <Box
      component="span"
      sx={{ display: "flex", alignItems: "center", gap: 1, perspective: "100px" }}
    >
      <LampSvg
        width={24}
        height={24}
        style={{
          filter: error
            ? "grayscale(1) opacity(0.6) drop-shadow(0 0 2px #ff0000) drop-shadow(0 0 5px #ff0000) drop-shadow(0 0 8px #ff0000)"
            : isUp
            ? "drop-shadow(0 0 8px #A39455) brightness(1.2)"
            : "grayscale(1) opacity(0.3)",
          transition: "filter 0.3s",
          animation: error ? `${pulseRed} 2s infinite` : isUp ? `${pulse} 2s infinite` : undefined,
        }}
      />
      {name}
    </Box>
  );

  return error ? (
    <Tooltip title={error} arrow placement="right">{content}</Tooltip>
  ) : content;
};
